/**
 * Stack floating widgets (no overlap):
 *   sticky cart / reminder  →  Shopify Inbox button  →  WhatsApp
 *
 * Important: modern Shopify Inbox uses a full-viewport <shopify-chat> host
 * (inset: 0). Only the button iframe should be moved — never the host.
 */
(function () {
  var GAP = 16;
  var RIGHT = 20;
  var SAFE = 16;

  function px(n) {
    return Math.round(n) + 'px';
  }

  function reminderHeight() {
    var bar = document.getElementById('CartReminderBar');
    if (bar && !bar.hidden && bar.classList.contains('is-visible')) {
      return bar.getBoundingClientRect().height || 0;
    }
    var sticky = document.querySelector('.sticky-cart-wr.active:not(.disable)');
    if (sticky && !document.body.classList.contains('has-cart-reminder-bar')) {
      return sticky.getBoundingClientRect().height || 0;
    }
    return 0;
  }

  function findWhatsApp() {
    return document.querySelector('.whatsapp-float');
  }

  function isLauncher(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    var rect = el.getBoundingClientRect();
    if (rect.width < 36 || rect.width > 90) return false;
    if (rect.height < 36 || rect.height > 90) return false;
    if (window.innerWidth - rect.right > 120) return false;
    if (window.innerHeight - rect.bottom > 420) return false;
    return true;
  }

  function findShadowLauncher(node, depth) {
    if (!node || depth > 6) return null;
    var root = node.shadowRoot || node;
    if (!root || !root.querySelectorAll) return null;
    var buttons = root.querySelectorAll('button, iframe');
    for (var i = 0; i < buttons.length; i++) {
      if (isLauncher(buttons[i])) return buttons[i];
    }
    var all = root.querySelectorAll('*');
    for (var j = 0; j < all.length; j++) {
      if (!all[j].shadowRoot) continue;
      var found = findShadowLauncher(all[j], depth + 1);
      if (found) return found;
    }
    return null;
  }

  function findInboxButton() {
    var selectors = [
      'iframe#dummy-chat-button-iframe',
      'iframe[name="dummy-chat-button-iframe"]',
      'iframe#ShopifyChat',
      'iframe[id*="chat-button" i]',
      'iframe[title="Chat button"]',
      'iframe[title*="Chat button" i]',
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (isLauncher(el)) return el;
    }

    var host = document.querySelector('shopify-chat');
    if (host) {
      var shadowButton = findShadowLauncher(host, 0);
      if (shadowButton) return shadowButton;
    }
    return null;
  }

  function place(el, bottom, right, z) {
    if (!el) return;
    el.style.setProperty('position', 'fixed', 'important');
    el.style.setProperty('bottom', px(bottom), 'important');
    el.style.setProperty('right', px(right), 'important');
    el.style.setProperty('left', 'auto', 'important');
    el.style.setProperty('top', 'auto', 'important');
    if (z) el.style.setProperty('z-index', String(z), 'important');
  }

  function visualBottom(el) {
    return window.innerHeight - el.getBoundingClientRect().bottom;
  }

  function visualRight(el) {
    return window.innerWidth - el.getBoundingClientRect().right;
  }

  function pin(el, bottom, right, z) {
    place(el, bottom, right, z);
    var bottomDelta = visualBottom(el) - bottom;
    var rightDelta = visualRight(el) - right;
    if (Math.abs(bottomDelta) > 1 || Math.abs(rightDelta) > 1) {
      place(el, bottom - bottomDelta, right - rightDelta, z);
    }
    var rect = el.getBoundingClientRect();
    return {
      bottom: window.innerHeight - rect.bottom,
      height: rect.height
    };
  }

  function stack() {
    var base = Math.max(reminderHeight() + GAP, SAFE);
    var inbox = findInboxButton();
    var wa = findWhatsApp();

    var inboxBottom = base;
    var inboxH = 0;

    var stackRight = RIGHT;

    if (inbox) {
      var pinnedInbox = pin(inbox, inboxBottom, RIGHT, 9997);
      inboxBottom = pinnedInbox.bottom;
      inboxH = pinnedInbox.height >= 36 && pinnedInbox.height <= 90 ? pinnedInbox.height : 46;
      stackRight = visualRight(inbox);
    }

    var waBottom = inbox ? inboxBottom + inboxH + GAP : base;

    if (wa) {
      var pinnedWa = pin(wa, waBottom, stackRight, 9998);
      wa.style.setProperty('--wa-float-bottom', px(pinnedWa.bottom));
      wa.style.setProperty('--wa-float-right', px(RIGHT));
    }

    document.documentElement.style.setProperty('--inbox-float-bottom', px(inboxBottom));
    document.documentElement.style.setProperty('--inbox-float-right', px(RIGHT));
    document.documentElement.style.setProperty('--wa-float-stack-bottom', px(waBottom));
    document.documentElement.style.setProperty('--float-stack-right', px(RIGHT));
    document.documentElement.style.setProperty('--float-stack-gap', px(GAP));
  }

  var timer = null;
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    clearTimeout(timer);
    timer = setTimeout(function () {
      scheduled = false;
      stack();
    }, 100);
  }

  window.addEventListener('resize', schedule);
  window.addEventListener('sticky-cart:change', schedule);
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('visibilitychange', schedule);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  [200, 600, 1200, 2500, 5000, 9000].forEach(function (ms) {
    setTimeout(schedule, ms);
  });

  if (window.MutationObserver) {
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)) {
          schedule();
          return;
        }
        if (m.type === 'attributes' && m.target) {
          var id = m.target.id || '';
          var tag = (m.target.tagName || '').toLowerCase();
          if (
            id.indexOf('chat') !== -1 ||
            id.indexOf('Chat') !== -1 ||
            tag === 'shopify-chat' ||
            tag === 'iframe' ||
            (m.target.classList && m.target.classList.contains('whatsapp-float'))
          ) {
            schedule();
            return;
          }
        }
      }
    });
    obs.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden'],
    });
  }
})();
